export const ICONS = {
  ADD: 'fal fa-plus',
  EDIT: 'fal fa-edit',
  DELETE: 'fal fa-trash',
  SAVE: 'fas fa-save',
  FILTER: 'fa-light fa-filter',
};